<script setup>
import UiAvatar from './UiAvatar.vue';

// A person's header for a dialog or card: photo (or initials), name, one
// line of context and an optional row of badges.
//   <UiProfileHeader :name="name" :photo="url" subtitle="Grade 8 · Sampaguita">
//     <UiBadge variant="green">Enrolled</UiBadge>
//   </UiProfileHeader>
defineProps({
  name: { type: String, default: '' },
  photo: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  size: { type: Number, default: 56 },
});
</script>

<template>
  <div class="ui-profile">
    <UiAvatar :name="name" :src="photo" :size="size" />
    <div class="ui-profile__text">
      <h2 class="ui-profile__name">{{ name }}</h2>
      <p v-if="subtitle" class="ui-profile__subtitle">{{ subtitle }}</p>
      <div v-if="$slots.default" class="ui-profile__badges"><slot /></div>
    </div>
  </div>
</template>

<style scoped>
.ui-profile {
  display: flex;
  align-items: center;
  gap: 14px;
}
.ui-profile__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.ui-profile__name {
  margin: 0;
  overflow: hidden;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ui-profile__subtitle {
  margin: 0;
  font-size: 14px;
  color: var(--muted-foreground);
}
.ui-profile__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}
</style>
